import React from 'react'

import { PasswordInputV4, TextInputV3 } from '@acorns/web-components'

import { FormItem, FormRow } from './styled-components'

// Temporary external conditional to handle the error state of password field.
// @Todo Once web reg matches mobile validation behavior, remove this external error state tracking function.

const CredentialsFormRow = ({
  errors,
  onChange,
  values,
  isEmailRowDisplayed,
  onEmailChange,
  onFocus,
  onKeyDown,
}) => (
  <>
    <FormRow>
      {isEmailRowDisplayed ? (
        <FormItem>
          <TextInputV3
            label={{
              value: 'Email',
            }}
            className="text-input"
            inputProps={{
              name: 'email',
              value: values.email,
              onChange: onEmailChange,
              id: 'email',
              type: 'email',
              placeholder: 'Email address',
              'data-testid': 'email_input',
              onFocus,
              onKeyDown,
            }}
            error={!!errors.email}
            errorText={errors.email}
          />
        </FormItem>
      ) : (
        <FormItem>
          <PasswordInputV4
            label="Password"
            value={values.password}
            className="text-input"
            name="password"
            inputVersion="v3"
            onChange={onChange}
            data-testid="password_input"
            required={true}
            placeholder="Password"
            errors={!!errors.password}
          />
        </FormItem>
      )}
    </FormRow>
  </>
)

export default CredentialsFormRow
